import React, { useState } from 'react';
import { Box, Typography, Accordion, AccordionSummary, AccordionDetails, Avatar } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const FaqSection = () => {
  const [expanded, setExpanded] = useState<string | false>(false);

  const handleChange = (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column', md: 'row' },
        backgroundColor: '',
        borderRadius: 4,
        overflow: 'hidden',
        py:{xs:3,lg:8},
        px:{xs:0,lg:4}
        
      }}
    >
      {/* Image Section */}
      <Box className="component"
        sx={{
          flex: 1,
          backgroundImage: `url('173156179008out.jpg')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          height: { xs: 250, md: 'auto' },
          mx:2,
          borderRadius:"20px"
        }}
      />

      {/* FAQ Section */}
      <Box className="component"
        sx={{
          flex: 1,
          p: 4,
          backgroundColor: '',
        }}
      >
        <Typography variant="h4" sx={{ color: '#012f57', mb: 5,fontWeight:'bold' }}>
        
            Frequently Asked <span
              style={{
                background:
                  "linear-gradient(-96deg, rgb(194 183 183 / 0%) 0%, rgb(255 249 220 / 4%) 28%, rgb(255, 162, 49) 100%, rgb(255 255 255 / 0%) 100%)",
                padding: "0px 2px",
                borderLeft: "2px solid rgba(253,150,16,1)",
              }}
            > Questions About Our Assignment </span>  Writing Services

        </Typography>

        <Accordion
          expanded={expanded === 'panel1'}
          onChange={handleChange('panel1')}
          sx={{ backgroundColor: '#012f57', color: '#fff', mb: 2 }}
        >
          <AccordionSummary expandIcon={<ExpandMoreIcon sx={{ color: '#fff' }} />}>
            <Typography>What services do you offer?</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              We provide assignment writing, editing, and research assistance for students across various academic levels.
            </Typography>
          </AccordionDetails>
        </Accordion>

        <Accordion
          expanded={expanded === 'panel2'}
          onChange={handleChange('panel2')}
          sx={{ backgroundColor: '#012f57', color: '#fff', mb: 2 }}
        >
          <AccordionSummary expandIcon={<ExpandMoreIcon sx={{ color: '#fff' }} />}>
            <Typography>Are your assignments plagiarism-free?</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              Yes, all assignments are 100% original, written from scratch, and verified through plagiarism-detection tools.
            </Typography>
          </AccordionDetails>
        </Accordion>

        <Accordion
          expanded={expanded === 'panel3'}
          onChange={handleChange('panel3')}
          sx={{ backgroundColor: '#012f57', color: '#fff', mb: 2 }}
        >
          <AccordionSummary expandIcon={<ExpandMoreIcon sx={{ color: '#fff' }} />}>
            <Typography>Who can use your services?</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              Our services are available to students, researchers, and professionals seeking academic or assignment writing support.
            </Typography>
          </AccordionDetails>
        </Accordion>

        <Accordion
          expanded={expanded === 'panel4'}
          onChange={handleChange('panel4')}
          sx={{ backgroundColor: '#012f57', color: '#fff', mb: 2 }}
        >
          <AccordionSummary expandIcon={<ExpandMoreIcon sx={{ color: '#fff' }} />}>
            <Typography>What is the delivery time for assignments?</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              Delivery time depends on the complexity and length of the assignment. We ensure timely delivery for all orders.
            </Typography>
          </AccordionDetails>
        </Accordion>

        <Accordion
          expanded={expanded === 'panel5'}
          onChange={handleChange('panel5')}
          sx={{ backgroundColor: '#012f57', color: '#fff', mb: 2 }}
        >
          <AccordionSummary expandIcon={<ExpandMoreIcon sx={{ color: '#fff' }} />}>
            <Typography>How experienced are your writers?</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              Our team consists of highly qualified professionals with expertise in various academic fields and years of writing experience.
            </Typography>
          </AccordionDetails>
        </Accordion>
      </Box>
    </Box>
  );
};

export default FaqSection;
